// Mirrors backend/libs/neutralizeText.js — keep in sync.
export function neutralizeText(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/\bthe sales representative\b/gi, 'the team')
    .replace(/\bthe sales rep\b/gi, 'the team')
    .replace(/\bthe salesperson\b/gi, 'the team')
    .replace(/\bsales representative\b/gi, 'the team')
    .replace(/\bsales rep\b/gi, 'the team')
    .replace(/\bsalesperson\b/gi, 'the team')
    .replace(/\bsalespeople\b/gi, 'the team')
    .replace(/\bthe rep\b/gi, 'the team')
    .replace(/\brep's\b/gi, "the team's")
    .replace(/\brep\b(?=\s)/gi, 'team')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

export default neutralizeText;
